"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = GradientBorder;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
function GradientBorder({ width = 1, radius, style, children, ...restProps }) {
    return ((0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { style: [style, { padding: width, borderRadius: radius }], ...restProps, children: children }));
}
;
